import { css, type Theme } from "@emotion/react";

import { dimensions } from "@styles";

export const container = css`
  display: flex;
  align-content: center;
  margin-top: 1.5rem;
  padding: 0 1rem;
  width: 100%;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    flex-direction: column;
    align-items: center;
  }
`;

export const or = css`
  align-self: center;
  margin: 0 0.5rem;
  text-transform: uppercase;

  @media (max-width: ${dimensions.phoneLargeMax}) {
    display: none;
  }
`;

export const envelope = (theme: Theme) => css`
  &&& {
    path {
      color: ${theme.success.textBase};
    }
  }

  margin-left: -0.25rem;
  margin-right: 1.25rem;
`;

export const emailButton = css`
  @media (max-width: ${dimensions.phoneLargeMax}) {
    margin-top: 1rem;
  }
`;

export const continueWithButton = css`
  margin-top: 1rem;
`;

export const fullWidth = css`
  width: 100%;
  text-align: center;
`;
